export type FeedbackCategory = 'improvement' | 'bug' | 'performance' | 'authentication';
export type FeedbackStatus = 'open' | 'in_progress' | 'resolved';

export interface FeedbackAttachment {
  url: string;
  fileName: string;
  mimeType: string;
}

export interface IBetaFeedback {
  _id: string;
  userId: string;
  userEmail: string;
  userName: string;
  category: FeedbackCategory;
  description: string;
  attachments: FeedbackAttachment[];
  status: FeedbackStatus;
  adminNotes?: string;
  createdAt: string;
  updatedAt: string;
}

export interface SubmitFeedbackPayload {
  category: FeedbackCategory;
  description: string;
  attachments?: File[];
}

export const CATEGORY_LABELS: Record<FeedbackCategory, string> = {
  improvement: 'Improvement Idea',
  bug: 'Bug Report',
  performance: 'Performance / Responsiveness Issue',
  authentication: 'Authentication / Login Issue',
};

export const STATUS_LABELS: Record<FeedbackStatus, string> = {
  open: 'Open',
  in_progress: 'In Progress',
  resolved: 'Resolved',
};

export const STATUS_COLORS: Record<FeedbackStatus, 'default' | 'warning' | 'success'> = {
  open: 'default',
  in_progress: 'warning',
  resolved: 'success',
};
